export const mapFlatLight = flat => ({
  id: flat.id,
  number: flat.number,
  area: flat.area,
  floor: flat.floor,
  currentPrice: flat.currentPrice,
  real_price: flat.real_price,
  redPrice: flat.redPrice,
  promo: flat.promo,
  mainBenefit: flat.mainBenefit,
  rooms: flat.rooms,
  price: flat.price,
  textPrice: flat.textPrice,
  attributes: flat.attributes,
  section: flat.section,
  status: flat.status,
  bulk: flat.bulk,
  bulk_id: flat.bulk_id,
  ceilingHeight: flat.ceilingHeight,
});
